import styled from "styled-components";

export const VoucherCardFaceCurrentAmountContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-family: ${props => props.theme.font.family.regular};
    font-size: 1.5rem;
    margin-top: 20px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin-top: 10px;
        font-size: 1.2rem;
    }
`;
